// WARNING: If you want to change the `data` field values below, make sure the mappings
// in the API (`SlotAvailabilityPreferenceModule` module in `ScoringModules.js` file)
// are also updated. Otherwise the Match Algorithm may break.

export const asapOption = {
  id: 'asap',
  title: 'As soon as possible',
  data: 'ASAP',
};

export const options = [
  asapOption,
  {
    id: 'within-1-week',
    title: 'Within 1 week',
    data: '1 week',
  },
  {
    id: 'within-2-week',
    title: 'Within 2 weeks',
    data: '2 weeks',
  },
  {
    id: '2+weeks',
    title: 'In more than 2 weeks',
    data: 'More than 2 weeks',
  },
];
